<template>
  <div
    :class="['home-page', {
      'home-page--no-title': !title
    }]"
  >
    <h1
      v-if="title"
      v-html="title"
    />

    <div
      v-if="title && $slots['sub-title']"
      class="sub-title"
    >
      <slot name="sub-title" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HomePage',
    props: {
      title: {
        type: String,
        required: false,
        default: null
      }
    }
  }
</script>

<style lang="scss" scoped>
  .home-page {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    min-height: rem(328px);
    max-width: $max-width + rem(48px);
    padding: rem(18px) rhythm() rhythm();
    margin: 0 auto;

    @include mq(medium) {
      min-height: rem(280px);
      max-width: $max-width + rem(48px);
      padding: rhythm();
    }

    @include mq(large) {
      align-items: center;
      justify-content: center;
      min-height: rem(256px);
      max-width: $max-width + rem(96px);
      padding: rhythm() rem(48px);
    }

    h1 {
      @include type-title-xl;

      color: color(white);
      margin: 0;

      @include mq(medium) {
        @include type-title-xxl;

        margin: 0;
      }

      @include mq(large) {
        max-width: rem(700px);
        font-size: rem(64px);
        text-align: center;
      }
    }

    .sub-title,
    .sub-title ::v-deep p {
      color: color(white);
      margin: 0;
    }
  }

  // ? ----------------------------------------------------------------------
  // modifiers
  // ? ----------------------------------------------------------------------

  .home-page--no-title {
    min-height: rem(132px);

    @include mq(medium) {
      min-height: rem(256px);
    }
  }
</style>
